module.exports = __webpack_public_path__ + "static/media/zuzhijigouyilantu.3f9a81fd.png";